import { Partner } from '@geovelo-frontends/commons';
import { DialogProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Dialog } from './dialog';

function ContactAdminDialog({
  partner,
  ...props
}: Omit<DialogProps, 'onClose'> & {
  partner: Partner;
  onClose: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog maxWidth="xs" {...props}>
      <Typography fontSize="1.25rem" fontWeight={600} marginBottom={1}>
        {t('companies.navigation.contact_admin')}
      </Typography>
      <Typography color="text.secondary" marginBottom={3} variant="body2">
        {t('companies.navigation.contact_admin_info')}
      </Typography>
      <Typography fontWeight={600}>{partner.contactEmail}</Typography>
    </Dialog>
  );
}

export default ContactAdminDialog;
